import { FaLinkedinIn, FaTwitter, FaInstagram } from "react-icons/fa";
import teamMember1 from "../../images/team/team-01.png";
import teamMember2 from "../../images/team/team-02.png";
import teamMember3 from "../../images/team/team-03.png";
import teamMember4 from "../../images/team/team-04.png";
import teamMember5 from "../../images/team/team-05.png";
import teamMember6 from "../../images/team/team-06.png";
import teamMember7 from "../../images/team/team-07.png";
import teamMember8 from "../../images/team/team-08.png";

const data = [
  {
    avatar: teamMember1,
    name: "Kevin Faringotan",
    designation: "Faunder , CEO",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: teamMember2,
    name: "Neha Faringotan",
    designation: "Co-Faunder , CTO",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: teamMember3,
    name: "Vicky Martinez",
    designation: "Chief Creative , Officer",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: teamMember4,
    name: "Alishia Fultean",
    designation: "Project Manager",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: teamMember5,
    name: "Joseph Holt",
    designation: "UI Designer",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: teamMember6,
    name: "Rosie Johnson",
    designation: "Software Engineer",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: teamMember7,
    name: "Mack Diaz",
    designation: "Blockchain Dev",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: teamMember8,
    name: "Leticia Carr",
    designation: "SEO Engineer",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
];

export default data;
